import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { Paper, Typography, Box } from '@mui/material';

// Function to generate random colors if no colors are provided
const generateRandomColors = (length) =>
  Array.from(
    { length },
    () =>
      `#${Math.floor(Math.random() * 16777215)
        .toString(16)
        .padStart(6, '0')}`
  );

// Main Ciclechart component
const Ciclechart = ({ data, title, colors, height = 300 }) => {
  const chartColors = colors?.length
    ? colors
    : generateRandomColors(data.length);

  const isAllZero = data.every(item => item.value === 0);


  return (
    <Paper sx={{ p: 2, borderRadius: 2, display: "flex", flexDirection: "column", boxShadow:"0px 0px 10px 0px #0000001A" }}>
      <Typography variant="h6" sx={{ marginBottom: 2, color: '#000' }}>
        {title}
      </Typography>
      <Box sx={{ width: '100%', height: height }}>
      {isAllZero ? (
        <Typography variant="body2" color="textSecondary">
          No task data to display.
        </Typography>
      ) : (
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={80}       // Increased from 60
              outerRadius={120}      // Increased from 80
              fill="#8884d8"
              paddingAngle={5}
              dataKey="value"
              nameKey="label"
              label
            >
              {data.map((_, index) => (
                <Cell key={`cell-${index}`} fill={chartColors[index]} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
        )}
      </Box>
    </Paper>
  );
};

export default Ciclechart;
